import { ChevronDown, ChevronRight, ChevronUp } from "@/features/shared/components/Chevrons";
import { cn } from "@/lib/utils";
import PercentageRing from "@/pages/new-platform/components/PercentageRing";
import { handleExpertRole, handleHourAndMinutes } from "@/utils/Functions";
import { cva } from "class-variance-authority";
import { useEffect, useState } from "react";
import { ControlPageCardItem } from "../../types/controlPageCardItem";
import { CardStatus } from "../../types/controlPanelPageCardStatus";
import { getDisplayDate } from "../../utils/functions";

const expandableCardVariants = cva(
    "w-full min-h-[50px] rounded-[5px] border border-solid border-border px-[10px] py-[13.5px] space-y-[20px] shadow-platform-new",
    {
        variants: {
            status: {
                focus: "border-primary",
                standard: "cursor-pointer",
                inactive: "text-muted shadow-0 pointer-events-none",
                completed: "text-muted shadow-0 pointer-events-none",
                permanent: "border-validation bg-validation-30",
                'permanent-go-through': "border-primary bg-primary-20",
            },
        },
        defaultVariants: {
        },
    }
)

interface CardssProps {
    item: ControlPageCardItem,
}

const Cardss = ({ item }: CardssProps) => {
    const [expanded, setExpanded] = useState(false);

    const handleToggle = () => {
        if (item.cheveronType === 'expand') {
            setExpanded((prev) => !prev);
        }
    };

    useEffect(() => {
        if ((item.status === CardStatus.Inactive || item.status === CardStatus.Completed) && expanded) {
            setExpanded(false); // Auto-collapse if status becomes inactive
        }
    }, [item.status]);

    const showChevron = item.cheveronType !== "none";

    return (
        <div
            className={cn(
                expandableCardVariants({ status: item.status }),
                item.cheveronType !== "none" &&
                (item.status === CardStatus.Focus || item.status === CardStatus.Permanent || item.status === CardStatus.PermanentGoThrough) &&
                "cursor-pointer"
            )}
            onClick={item.onClick || handleToggle}
        >
            <div
                className="w-full h-full flex items-center justify-between"
            >
                <div className="flex items-center gap-2">
                    {item.percentage !== null && <PercentageRing percentage={item.percentage} />}
                    <div className="font-medium">{item.text}</div>
                    {item.expertRole && <div className="font-bold text-xxs text-primary">{handleExpertRole(item.expertRole)}</div>}
                </div>
                {
                    showChevron && (
                        <div className="flex items-center gap-4">
                            {
                                item.consult && <div className="font-medium text-[10px]">
                                    <strong>{getDisplayDate(item.consult)}</strong> <span>{handleHourAndMinutes(item.consult.date)}</span>
                                </div>
                            }
                            {
                                item.extraText && <div className="text-xs">{item.extraText}</div>
                            }
                            <div>
                                {
                                    item.cheveronType === 'expand' ?
                                        !expanded ? <ChevronDown color={(item.status === CardStatus.Inactive || item.status === CardStatus.Completed) ? "text-border" : "text-foreground"} /> : <ChevronUp color={item.status === CardStatus.Inactive ? "text-border" : "text-foreground"} />
                                        : <ChevronRight />
                                }
                            </div>
                        </div>
                    )
                }
            </div>
            {expanded && item.expandedChildren}
        </div>
    )
}

export default Cardss
